// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate, Link } from 'react-router-dom';
// import { loginRequest } from '../redux/slices/authSlice';
// import { Lock, Mail } from 'lucide-react';
// import SEO from '../components/SEO';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { loading, error, token, role } = useSelector(state => state.auth);

//   useEffect(() => {
//     if (token) navigate(role === 'super_admin' ? '/admin' : '/dashboard');
//   }, [token, role, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(loginRequest({ email, password }));
//   };

//   return (
//     <div className="min-h-[80vh] flex items-center justify-center px-4">
//       <SEO title="Login" />
//       <div className="max-w-md w-full bg-qrypt-card p-8 rounded-2xl border border-gray-700 shadow-2xl">
//         <h2 className="text-3xl font-bold text-center mb-6 text-white">Welcome Back</h2>
//         {error && <p className="text-red-500 text-center mb-4 font-semibold bg-red-500/10 p-2 rounded">{error}</p>}

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label className="block text-gray-400 mb-2 text-sm">Email Address</label>
//             <div className="relative">
//               <Mail className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//               <input type="email" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:outline-none focus:border-qrypt-primary transition" value={email} onChange={(e) => setEmail(e.target.value)} required />
//             </div>
//           </div>
//           <div>
//             <label className="block text-gray-400 mb-2 text-sm">Password</label>
//             <div className="relative">
//               <Lock className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//               <input type="password" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:outline-none focus:border-qrypt-primary transition" value={password} onChange={(e) => setPassword(e.target.value)} required />
//             </div>
//           </div>
//           <button type="submit" disabled={loading} className="w-full bg-qrypt-primary hover:bg-blue-600 disabled:bg-gray-600 text-white font-bold py-3 rounded-lg transition shadow-lg">
//             {loading ? "Authenticating..." : "Login"}
//           </button>
//         </form>
//         <p className="mt-6 text-center text-gray-400 text-sm">
//           Need an account? <Link to="/register" className="text-qrypt-primary hover:underline font-bold ml-1">Register here</Link>
//         </p>
//       </div>
//     </div>
//   );
// };
// export default Login;

// change code 25/02/2026
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { loginRequest, logout } from "../redux/slices/authSlice";
import { Lock, Mail, Loader2, ArrowRight, Eye, EyeOff } from "lucide-react";
import SEO from "../components/SEO";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, token, role } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token) return;

    // Token without role means stale session from storage; clear it to avoid redirect loops
    if (!role) {
      dispatch(logout());
      return;
    }

    navigate(role === "super_admin" ? "/admin" : "/dashboard");
  }, [token, role, navigate, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginRequest({ email, password }));
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 overflow-hidden bg-[#0B0F19]">
      <SEO title="Login - QryptShield" />

      <div className="absolute inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: `linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/20 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 w-full max-w-md animate-in fade-in zoom-in duration-500 mt-14">
        <div className="bg-white/[0.03] backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl shadow-black/50 p-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-white mb-2">Welcome Back</h2>
            <p className="text-gray-400 text-sm">
              Enter your credentials to access the secure tunnel.
            </p>
          </div>

          {error && (
            <div className="mb-6 p-4 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm text-center font-medium animate-pulse">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-xs font-medium text-gray-400 uppercase tracking-wider ml-1">
                Email Address
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-500 group-focus-within:text-blue-400 transition-colors" />
                </div>
                <input
                  type="email"
                  className="block w-full pl-11 pr-4 py-3.5 bg-slate-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all duration-200"
                  placeholder="name@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center ml-1">
                <label className="text-xs font-medium text-gray-400 uppercase tracking-wider">
                  Password
                </label>
                <Link
                  to="/forgot-password"
                  className="text-xs text-blue-400 hover:text-blue-300 transition"
                >
                  Forgot password?
                </Link>
              </div>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-500 group-focus-within:text-blue-400 transition-colors" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  className="block w-full pl-11 pr-11 py-3.5 bg-slate-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all duration-200"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-500 hover:text-white"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5" />
                  ) : (
                    <Eye className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full relative group flex justify-center items-center py-3.5 px-4 border border-transparent rounded-xl text-white font-bold bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-blue-500 transition-all duration-300 shadow-lg shadow-blue-500/20 disabled:opacity-70 disabled:cursor-not-allowed mt-2"
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin -ml-1 mr-2 h-5 w-5" />
                  Verifying...
                </>
              ) : (
                <>
                  Sign In{" "}
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </>
              )}
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-400 text-sm">
              Don't have an account?{" "}
              <Link
                to="/register"
                className="font-semibold text-blue-400 hover:text-blue-300 transition hover:underline"
              >
                Create one now
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
